export default __webpack_public_path__ + "static/media/Untitled_Artwork 13.5a980857.png";